import { Link } from "react-router";
import { CheckCircle } from "lucide-react";
import { LOGIN_PATH } from "@/features/auth/routes";
import type { TransferRequest } from "@/features/employeeTransfer/types/employeeTransfer.types";
import { H2 } from "@/shared/ui/typographies/h2";
import { P } from "@/shared/ui/typographies/paragraph";

type SuccessScreenProps = { transferRequest: TransferRequest };

export const SuccessScreen = ({ transferRequest }: SuccessScreenProps) => {
  const { target_organization_name: targetOrg, source_organization_name: sourceOrg } = transferRequest;

  return (
    <div className="overflow-hidden rounded-xl" aria-live="polite">
      <div className="bg-teal-50/80 px-6 py-8 dark:bg-teal-950/20">
        <div className="flex flex-col items-center text-center">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-teal-100 dark:bg-teal-900/30">
            <CheckCircle size={28} className="text-teal-600 dark:text-teal-400" />
          </div>
          <H2 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">
            Transfert confirmé
          </H2>
          <P size="sm" color="base" className="text-pretty tracking-wider">
            Votre compte a été transféré vers
            {" "}
            <strong className="text-gray-900 dark:text-white">{targetOrg}</strong>
            .
          </P>
        </div>
      </div>

      <div className="space-y-4 px-6 pb-6 pt-4">
        <div className="space-y-4 rounded-lg border border-teal-100 bg-teal-50/50 p-4 text-left dark:border-teal-900 dark:bg-teal-950/20">
          <P size="sm" color="base" className="text-pretty tracking-wider">
            Vos données personnelles, votre carte de paiement et vos soldes actifs sont
            désormais gérés par
            {" "}
            <strong>{targetOrg}</strong>
            .
          </P>
          <P size="sm" color="base" className="text-pretty tracking-wider">
            Votre ancien CSE (
            <strong>{sourceOrg}</strong>
            ) ne gère plus votre compte.
          </P>
        </div>

        <Link
          to={LOGIN_PATH}
          className="block w-full rounded-lg bg-teal-600 px-6 py-3 text-center text-base font-semibold text-white shadow-sm transition-colors hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 dark:bg-teal-600 dark:hover:bg-teal-500 dark:focus:ring-offset-gray-900"
        >
          Connectez-vous
        </Link>
      </div>
    </div>
  );
};
